// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".property-label[data-v-787754b7],.value-label[data-v-787754b7]{font-size:14px}.value-label[data-v-787754b7]{word-wrap:break-word;color:#2c2c2c}", ""]);
// Exports
module.exports = exports;
